const deleteCompaniesStr = {
  toastr: 'Deleted company',
  toastr1: ' successfully deleted'
};

export default deleteCompaniesStr;
